var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.disclaimer)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }